<template>
    <b-table
            :busy="claim_attachment_busy"
            :current-page="claim_attachment_currentPage"
            :fields="fields"
            :items="attachments"
            :per-page="claim_attachment_perPage"
            :sort-by="sortBy"
            :sort-desc="sortDesc"
            :sort-direction="sortDirection"
            responsive
            striped
            tbody-tr-class="rowClass"
            v-if="attachments.length > 0">
        <template #cell(hash)="data">{{data.value | hex_format(10,'....')}}</template>
        <template #cell(created)="data">{{ data.value | date }}</template>
        <template #cell(name)="data">{{ data.value | hex_format(8,'....') }}</template>
        <template #cell(download)="data">
            <a @click="downloadAttachment(data, 'claim')"
               class="text-inverse"
               data-original-title="Download"
               data-toggle="tooltip"
               href="javascript:void(0)"
               title=""><i class="fa fa-download fa-border"></i>
            </a>
        </template>
    </b-table>
</template>

<script>
    export default {
        name: "ClaimAttachments",
        props: ['attachments', 'memberid', 'claim_id'],
        data() {
            return {
                fields: [
                    {
                        key: 'property_name',
                        label: 'Name',
                    },
                    {
                        key: 'name',
                        label: 'File Name',
                        sortable: true
                    },
                    {
                        key: 'hash',
                        label: 'File Hash'
                    },
                    {
                        key: 'created',
                        label: 'Created on',
                    },
                    {
                        key: 'download',
                        label: 'Action',
                    }
                ],
                sortBy: 'name',
                sortDesc: false,
                sortDirection: 'asc',
                did_attachments: [],
                claim_attachment_busy: false,
                claim_attachment_currentPage: 1,
                claim_attachment_perPage: 5,
                claim_attachment_totalRows: 0,
            }
        },
        methods: {
            async downloadAttachment(attachment, type) {
                let reply = await this.$identity.get(`identity/dids/${this.memberid}/claims/${this.claim_id}/documents/${attachment.item.id}`);
                let link = document.createElement('a');
                link.href = 'data:application/octet-stream;base64,' + reply.data;
                link.download = attachment.item.name;
                link.click();
            },
        }
    }
</script>

<style scoped>

</style>
